import { config } from '@shakkerai/config';

export const inferenceAPIBucket = {
  sourceStorage: config?.env === 'aliyun' ? 'Aliyun' : 'ALIYUN-GLOBAL',
  sourceBucket: config.oss.ossBucket,
  targetStorage: config?.env === 'aliyun' ? 'Aliyun' : 'ALIYUN-GLOBAL',
  targetBucket: config.oss.ossBucket,
};
